// ============================================================
// parkUtils.js — Logique métier partagée pour les parcs
// Contient les fonctions de calcul de dates et de couleurs,
// utilisées à la fois par calls.js (liste) et MapApp.js (carte).
// ============================================================

import { COLOR_RED, COLOR_GREEN, COLOR_ORANGE, COLOR_PURPLE, FILTER_DONE, FILTER_NEEDED, FILTER_URGENT, FILTER_STANDBY } from './constants';

// Ajoute n mois à une date et retourne un objet Date
export const add_months = (date, n) => {
    let dt = new Date(date);
    return new Date(dt.setMonth(dt.getMonth() + n));
};

// Retourne la date maximale de contrôle (ControlDate + 15 mois)
// Au-delà, le contrôle est considéré urgent (rouge)
export const getMaxControlDate = (client) => {
    if (client.ControlDate !== undefined) {
        return add_months(client.ControlDate, 15);
    }
    return null;
};

// Retourne la date favorable de contrôle (ControlDate + 12 mois)
// Au-delà, un nouveau contrôle est souhaitable (orange)
export const getFavorableControlDate = (client) => {
    if (client.ControlDate !== undefined) {
        return add_months(client.ControlDate, 12);
    }
    return null;
};

// Calcule la différence absolue en jours entre deux dates
export const getDifferenceInDays = (date1, date2) => {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / (1000 * 60 * 60 * 24);
};

// Formate une date en chaîne "YYYY-MM-DD" (format ISO pour les inputs HTML)
export const formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day   = '' + d.getDate(),
        year  = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2)   day   = '0' + day;
    return [year, month, day].join('-');
};

// Détermine la couleur d'un parc selon son état :
//   - Violet  : parc en standby
//   - Rouge   : jamais contrôlé OU date max (15 mois) dépassée
//   - Orange  : date favorable (12 mois) dépassée mais pas encore critique
//   - Vert    : contrôle à jour
export const getColor = (client) => {
    if (!!client.standby) return COLOR_PURPLE;
    const maxDate = getMaxControlDate(client);
    const favDate = getFavorableControlDate(client);
    if (!client.ControlDate || client.ControlDate === 0 || new Date() > Date.parse(maxDate)) {
        return COLOR_RED;
    } else if (new Date() > Date.parse(favDate)) {
        return COLOR_ORANGE;
    } else {
        return COLOR_GREEN;
    }
};

// Convertit le code couleur (entier) en nom CSS pour les bandes
// colorées de la liste et les bordures visuelles
export const colorExclamation = (client) => {
    const color = getColor(client);
    if (color === COLOR_PURPLE) return 'purple';
    return color === COLOR_RED ? 'red' : (color === COLOR_ORANGE ? 'orange' : 'green');
};

// Filtre une liste de parcs selon les trois critères (statut, texte, expert).
// Centralisé ici pour éviter la duplication entre calls.js et MapApp.js.
export const filterParks = (clients, filterControl, filterClient, filterUserControl) => {
    let filteredList = clients || [];

    // Filtrage par statut
    if (filterControl === FILTER_DONE) {
        filteredList = filteredList.filter(client => !client.standby && new Date() < Date.parse(getFavorableControlDate(client)));
    } else if (filterControl === FILTER_NEEDED) {
        filteredList = filteredList.filter(client => !client.standby && new Date() > Date.parse(getFavorableControlDate(client)));
    } else if (filterControl === FILTER_URGENT) {
        filteredList = filteredList.filter(client => !client.standby && new Date() > Date.parse(getMaxControlDate(client)));
    } else if (filterControl === FILTER_STANDBY) {
        filteredList = filteredList.filter(client => !!client.standby);
    }
    // FILTER_ALL et null : aucun filtre, on garde tout

    // Filtrage par texte
    if (filterClient && String(filterClient).trim().length > 0) {
        const term = String(filterClient).toLowerCase();
        filteredList = filteredList.filter(client => client.name && client.name.toLowerCase().includes(term));
    }

    // Filtrage par expert
    if (filterUserControl !== null && filterUserControl !== undefined) {
        filteredList = filteredList.filter(client => client.userControlId === filterUserControl);
    }

    return filteredList;
};
